import System from './System.vue';
export default System;
